module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user_feedback_list clearfix p_background"
  }, [_c('h3', {
    staticClass: "all_title"
  }, [_vm._v("用户反馈")]), _vm._v(" "), _c('section', {
    staticClass: "all_container container_box"
  }, [_c('div', {
    staticClass: "all_state clearfix"
  }, [_c('div', {
    staticClass: "state_left"
  }, [_c('ul', [_c('li', {
    staticClass: "state_active",
    attrs: {
      "id": "manage_all"
    },
    on: {
      "click": function($event) {
        return _vm.initData('')
      }
    }
  }, [_vm._v("全部")]), _vm._v(" "), _c('li', {
    staticClass: "state_active",
    attrs: {
      "id": "manage_all1"
    },
    on: {
      "click": function($event) {
        return _vm.initData('1')
      }
    }
  }, [_vm._v("已回复（" + _vm._s(_vm.answer1count) + "）")]), _vm._v(" "), _c('li', {
    staticClass: "state_active",
    attrs: {
      "id": "manage_all2"
    },
    on: {
      "click": function($event) {
        return _vm.initData('0')
      }
    }
  }, [_vm._v("未回复（" + _vm._s(_vm.answer0count) + "）")])])])]), _vm._v(" "), _c('div', {
    staticClass: "table_box clearfix"
  }, [_c('table', {
    staticClass: "table table-hover text-center"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', {
    staticClass: "color_3"
  }, [_vm._l((_vm.page.content), function(feedback, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(feedback.schoolName))]), _vm._v(" "), (feedback.feedbackType == '1') ? _c('td', [_vm._v("平台反馈")]) : _vm._e(), _vm._v(" "), (feedback.feedbackType == '2') ? _c('td', [_vm._v("意见建议")]) : _vm._e(), _vm._v(" "), (feedback.feedbackType == '3') ? _c('td', [_vm._v("应用反馈"), (feedback.appName != null) ? _c('span', [_vm._v("-" + _vm._s(feedback.appName))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("datetime")(feedback.feedbackTime)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(feedback.schoolcloudUserUsername))]), _vm._v(" "), _c('td', [(feedback.answerStatus == '1') ? _c('div', {
      staticClass: "line_block"
    }, [_c('span', {
      staticClass: "margin_r_7"
    }, [_vm._v("已回复")]), _vm._v(" "), _c('a', {
      staticClass: "btn_text",
      on: {
        "click": function($event) {
          return _vm.view(feedback.id, 'feedback_detail')
        }
      }
    }, [_vm._v("查看")])]) : _vm._e(), _vm._v(" "), (feedback.answerStatus == '0') ? _c('a', {
      staticClass: "btn_text",
      on: {
        "click": function($event) {
          return _vm.view(feedback.id, 'feedback_reply')
        }
      }
    }, [_vm._v("回复")]) : _vm._e()])])
  }), _vm._v(" "), (_vm.page.content == '') ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("暂无数据")])]) : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "text-center",
    class: _vm.page.totalPages > 0 ? 'show' : 'hidden'
  }, [_c('div', {
    staticClass: "row-fluid"
  }, [_c('nav', [_c('ul', {
    staticClass: "pagination"
  }, [_c('li', {
    staticClass: "disabled",
    class: _vm.page.first ? 'disabled' : ''
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "aria-label": "Previous"
    },
    on: {
      "click": function($event) {
        return _vm.turnPage(_vm.page.url, _vm.page.previousPage)
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("«")])])]), _vm._v(" "), _vm._l((_vm.page.totalPages), function(i) {
    return _c('li', {
      class: _vm.page.number == (i - 1) ? 'active' : ''
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      domProps: {
        "textContent": _vm._s(i)
      },
      on: {
        "click": function($event) {
          return _vm.turnPage(_vm.page.url, i - 1)
        }
      }
    }, [_vm._v("1")])])
  }), _vm._v(" "), _c('li', {
    class: _vm.page.last ? 'disabled' : ''
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "aria-label": "Next"
    },
    on: {
      "click": function($event) {
        return _vm.turnPage(_vm.page.url, _vm.page.nextPage)
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("»")])])])], 2)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("归属学校")]), _vm._v(" "), _c('th', [_vm._v("反馈类型")]), _vm._v(" "), _c('th', [_vm._v("提交时间")]), _vm._v(" "), _c('th', [_vm._v("反馈人")]), _vm._v(" "), _c('th', [_vm._v("操作")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-77acba06"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/user_feedback/list.vue
// module id = 1268
// module chunks = 1